var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 35.7188C22.36 35.7188 22.15 35.6484 22.01 35.5078L5.56 18.9844C5.28 18.7031 5.28 18.2812 5.56 18C5.84 17.7188 6.26 17.7188 6.54 18L21.8 33.3281V0.703125C21.8 0.28125 22.08 0 22.5 0C22.92 0 23.2 0.28125 23.2 0.703125V33.3281L38.46 18C38.74 17.7188 39.16 17.7188 39.44 18C39.72 18.2812 39.72 18.7031 39.44 18.9844L22.99 35.5078C22.85 35.6484 22.64 35.7188 22.5 35.7188Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1 31.2188C42.1 30.7969 42.38 30.5156 42.8 30.5156C43.22 30.5156 43.5 30.7969 43.5 31.2188V37.7578C43.5 41.7656 40.28 45 36.29 45H8.71C4.72 45 1.5 41.7656 1.5 37.7578V31.2188C1.5 30.7969 1.78 30.5156 2.2 30.5156C2.62 30.5156 2.9 30.7969 2.9 31.2188V37.7578C2.9 40.9922 5.49 43.5938 8.71 43.5938H36.29C39.51 43.5938 42.1 40.9922 42.1 37.7578V31.2188Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLg);
export default __webpack_public_path__ + "static/media/downloadLg.44afd0cfdfe8a20421d45babcb9dd76a.svg";
export { ForwardRef as ReactComponent };